import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "@/lib/toast";
import { useAuth } from "@/context/AuthContext";
import { hasRight } from "@/components/crm/crmShared";

export const ACCESS_DENIED_MSG = "Accès non autorisé — contactez un administrateur";

/** LOT 4 — garde de route par droit `module.action` (accès direct par URL → toast + retour Dashboard). */
export default function RightsRoute({ right, children }) {
  const { user } = useAuth();
  const ok = !user || hasRight(user, right);
  useEffect(() => { if (user && !ok) toast.error(ACCESS_DENIED_MSG, { id: "access-denied" }); }, [ok, user]);
  if (!user) return null;
  if (!ok) return <Navigate to="/tableau-de-bord" replace />;
  return children;
}
